module.exports = __webpack_public_path__ + "static/mirai-1d393aceb5d77ac6e0f714d449371481.svg";